module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69719/img/content-remix-post-publish/content-remix-pt.png"